// import React from "react";
// import Topbar from "../components/TopbarNav";
// import Disciplinary from "../components/Disciplinary";
// import Sidebar from "../components/Sidebar";


// const handleLogout = () => {
//     localStorage.removeItem("token");
//     window.location.href = "/";
//   };

// function DisciplinaryInterface() {
//   return (
//     <div className="flex">
//       {/* Sidebar */}
//       <div className="w-64 fixed h-screen z-50">
//         <Sidebar onLogout={handleLogout} />
//       </div>

//       {/* Main Content Area */}
//       <div className="flex-1 ml-64">
//         {/* Topbar */}
//         <div className="fixed top-0 left-64 right-0 z-40">
//           <Topbar />
//         </div>

//         {/* Page Content */}
//         <div className="pt-11 px-4"> {/* push content below topbar */}
//           <Disciplinary />
//         </div>
//       </div>
//     </div>
//   );
// }

// export default DisciplinaryInterface;
import React from "react";
import Topbar from "../components/TopbarNav";
import Disciplinary from "../components/Disciplinary";
import Sidebar from "../components/MasterSideBar";

const DisciplinaryInterface = () => {
  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  return (
    <div className="flex min-h-screen w-full bg-gray-50 font-sans">
      {/* Sidebar */}
      <Sidebar onLogout={handleLogout} />

      {/* Main Content */}
      <div className="flex-1 relative overflow-y-auto md:ml-64">
        {/* Topbar */}
        <div className="fixed top-0 left-0 md:left-64 right-0 z-10">
          <Topbar />
        </div>

        {/* Page Content */}
        <main className="pt-20 px-4 md:px-6">
          <h1 className="text-xl font-bold text-gray-700 mb-6">
            Disciplinary Records
          </h1>
          <Disciplinary />
        </main>
      </div>
    </div>
  );
};

export default DisciplinaryInterface;
